import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { TextField, useMediaQuery } from "@mui/material";
import { Search } from "tabler-icons-react";
import { InputAdornment } from "@mui/material";
import { translate } from "../../utils/utils";
import Checkbox from "@mui/material/Checkbox";
import {
  requestAddAnswersQuiz,
  requestForwardToAFriend,
} from "../../redux/actions/quizzesActionCreators";
import { useHistory } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function AddUser({
  open,
  handleClose,
  forwarded,
  forwardList,
  handleForwardList,
  quiz_id,
  answers,
  version,
  identifier,
  handleRemoveLists,
  forward_id,
  ref,
  idUseCase,
  thresholdsPayload,
  pourcentageQuiz,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const orgaId = localStorage.getItem("orgaId");
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;

  const [search, setSearch] = useState("");

  const isMobile = useMediaQuery("(max-width:1400px)");

  const handleUser = (usecaseId, email) => {
    if (!forwardList.some((item) => item.usecase_id === usecaseId)) {
      handleForwardList((prevState) => [
        ...prevState,
        {
          usecase_id: usecaseId,
          forwarded_to: email,
          answered: false,
          threshold: 0,
        },
      ]);
    } else {
      handleForwardList(
        forwardList.filter((el) => el.usecase_id !== usecaseId)
      );
    }
  };
  const handleSave = () => {
    dispatch(
      requestAddAnswersQuiz(
        {
          quiz_id: quiz_id,
          answers: {
            questions: answers,
            usecases: { ...thresholdsPayload },
          },
          is_completed: false,
          version: version,
          identifier: identifier,
          pourcentage: pourcentageQuiz,
        },

        orgaId,
        accountType
      )
    );
    handleClose();
    handleRemoveLists();
  };

  const handleForward = () => {
    let thresholdsPayloadForward = {};
    forwardList.forEach((element) => {
      thresholdsPayloadForward = {
        ...thresholdsPayloadForward,
        [element.usecase_id]: 0,
      };
    });
    dispatch(
      requestForwardToAFriend(
        {
          quiz_id: quiz_id,
          answers: {
            questions: answers,
            usecases: { ...thresholdsPayload, ...thresholdsPayloadForward },
          },
          is_completed: false,
          version: version,
          identifier: identifier,
          forwarded_usecases: forwardList,
          forward_id: forward_id,
          pourcentage: pourcentageQuiz,
          forward_id: forward_id,
        },
        orgaId,
        accountType
      )
    );
    handleClose();
    handleRemoveLists();
    history.goBack();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
          setSearch("");
        }}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "60%", padding: "20px" }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton
            onClick={() => {
              handleClose();
              setSearch("");
            }}
          >
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle>
          <Typography variant="title4">{t("confirm_forard")}</Typography>
        </DialogTitle>
        <DialogContent>
          <TableContainer
            component={Paper}
            className="scrollhost"
            sx={{
              width: "100%",
              "&.MuiTableContainer-root": {
                borderRadius: "0px",
                boxShadow: "none",
              },
              mt: !isMobile ? 3 : 0,
            }}
          >
            <Table
              stickyHeader
              aria-label="customized table"
              sx={{
                width: "100%",
                "& .MuiTableRow-root:hover": {
                  backgroundColor: "#DDF6F0",
                  cursor: "pointer",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left" width="1%"></StyledTableCell>
                  <StyledTableCell align="left" width="24%">
                    {t("name")}
                  </StyledTableCell>
                  <StyledTableCell align="center" width="75%%">
                    {t("usecases")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {forwarded?.map((el) => (
                  <StyledTableRow
                    key={el.id}
                    onClick={() => handleUser(el.usecase_id, el.email)}
                    sx={{
                      backgroundColor:
                        forwardList?.some(
                          (item) => item.usecase_id === el.usecase_id
                        ) && "#F3FBF9",
                    }}
                  >
                    <StyledTableCell align="center">
                      <Checkbox
                        checked={forwardList?.some(
                          (item) => item.usecase_id === el.usecase_id
                        )}
                        color="success"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {el?.fullName}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {el?.[translate("title")]}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-around", mt: 4 }}>
          <Button
            variant="contained"
            color="pending"
            sx={{ width: "47%" }}
            onClick={handleSave}
          >
            {t("save_and_cancel")}
          </Button>
          <Button
            variant="contained"
            color="button"
            sx={{ width: "47%" }}
            onClick={handleForward}
          >
            {t("save_and_forward")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
